import { useEffect, useRef } from 'react';

export interface DeepLinkResult {
  type: 'pin' | 'event' | 'user' | null;
  id: string | null;
}

export function useDeepLinks(): DeepLinkResult {
  const resultRef = useRef<DeepLinkResult>({ type: null, id: null });
  const processedRef = useRef(false);

  useEffect(() => {
    if (processedRef.current) return;
    processedRef.current = true;

    const params = new URLSearchParams(window.location.search);
    const pinId = params.get('pin');
    const eventId = params.get('event');
    const userId = params.get('user');

    if (pinId) {
      resultRef.current = { type: 'pin', id: pinId };
    } else if (eventId) {
      resultRef.current = { type: 'event', id: eventId };
    } else if (userId) {
      resultRef.current = { type: 'user', id: userId };
    }

    // Clean URL after reading
    if (pinId || eventId || userId) {
      const clean = window.location.origin + window.location.pathname;
      window.history.replaceState({}, '', clean);
    }
  }, []);

  return resultRef.current;
}
